import React, { Component } from 'react';
import Catalogue from '../../../components/Catalogue';
import "../../../css/general-style.css";
import '../../../css/pickingSystem-style.css';
import '../../../css/dashboard.css';
import { AiOutlineSearch, AiTwotoneSave, AiOutlineCheckCircle, AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineZoomIn, AiOutlineMinusSquare } from "react-icons/ai";
import { BsFileArrowUpFill, BsFileArrowDownFill, BsBoxSeam } from "react-icons/bs";
import ModalOrders from '../../../components/ModalComponent';
import { getValueCookie } from '../../../services/cookieService';
import { create_Delete_Update_Information, getInformationWithData, getInformationWithDataGlobalSales, getInformationWithDataV3 } from '../../../services/CABE';
import { DateFormatMAS90, formatInputDateQuery, FormatQueryReturnDateForReport, getActualDateUTC } from '../../../functions/dateFormat';
import { getIndexElement } from '../../../functions/searchInObject';
import Swal from 'sweetalert2';
import { OrderPDF } from '../../../components/OrderPDF';
import { getPrintHeaderCompany } from '../../../functions/companyInformation';
import { pricesFormat } from '../../../functions/pricesFormat';
import SearchUPC from '../../../components/SearchUPC';
import { DecimalPart, decimalToHour, DeleteStrangeCharacter, MobileDisp, NumberFormat, OrderArray, ReplaceCharacter, validateNumbersForQuantitys } from '../../../functions/generalFunctions';
import { confirmCloseAlert } from '../../../functions/alerts';
import LoadingWindow from '../../../components/LoadingWindow';
import { DownloadOrderPDF } from '../../../components/DownloadOrderPDF';
import { NotificationBell } from '../../../components/NotificationBell';
import server from "../../../services/Connection/backEndLink";
import axios from "axios";
import { Menu } from "../../../components/Menu/Menu";

export default class WarehousePicking extends Component {
  constructor(props) {
    super(props)
    this.ModalLoading = React.createRef();
    this.searchTimeout = null;
  }
  state = {
    Inventory: [],
    // Full /v3/salesorder/catalog rows (itemCode + longDescription among other
    // fields), fetched once and cached — see fetchCatalogV3(). Not reset by
    // clearAll(), same lifecycle as Inventory above.
    Catalog: [],
    General: {
      ModeTitle: 'Sales Order',
      Mode: 'S/O',
      Colorclass: 'purpleLightButton',
      showModal1: false,
      showModal2: false,
      currentPallet: '01'
    },
    bandera: true,
    OrderHeaderList: [],
    filteredOrderList: [],
    searchSO: '',
    OrderDetailPicked: [],
    OrderDetailPickedToPrint: [],
    OrderDetailtoPick: [],
    ActualHeaderOrder: {
      Status: '',
      OrderNo: '',
      OrderName: '',
      OrderName2: '',
      OrderNameNo: '',
      OrderNameAddress: '',
      OrderNameCity: '',
      Date: '',
      SalesPerson: '',
      ZipCode: '',
      State: '',
      Order: null,
      Packing: ''
    },
    CurrentItem: {
      ItemCode: '',
      Description: { Description: '', longDescription: '' },
      onHand: 0,
      QuantityOrdered: 0,
      QuantityShipRec: 0,
      BIN: '',
      Pallet: '',
      UnitPrice: '',
      ImgURL: '',
      RegisterType: '',
      HaveUPC: false,
      DueDate: null
    },

    Totals: {

      OrderDetailtoPick: {
        QuantityOrdered: 0,
        TotalWeight: 0
      },
      OrderDetailPicked: {
        QuantityOrdered: 0,
        QuantityShipRec: 0,
        TotalWeight: 0
      }
    },
    companyPrintHeader: getPrintHeaderCompany(),
    PercentageScanning: 0,
    PercentageManual: 0,
    TotalManual: 0,
    TotalScanning: 0,
    order: true,
    changedSOItems: [],
    showCustomerTab: true,
    // Guards getActualOrders() against a double/rapid click on "Search"
    // firing two overlapping fetch chains — see getActualOrders() below.
    loadingOrders: false,
  }

  clearAll() {
    const temporal = this.state.General
    temporal.currentPallet = '01'
    this.setState({
      OrderHeaderList: [],
      filteredOrderList: [],
      OrderDetailPicked: [],
      OrderDetailPickedToPrint: [],
      OrderDetailtoPick: [],
      ActualHeaderOrder: {
        Status: '',
        OrderNo: '',
        OrderName: '',
        OrderName2: '',
        OrderNameNo: '',
        OrderNameAddress: '',
        OrderNameCity: '',
        Date: '',
        SalesPerson: '',
        ZipCode: '',
        State: '',
        Order: null,
        Packing: ''
      },
      CurrentItem: {
        ItemCode: '',
        Description: { Description: '', longDescription: '' },
        onHand: 0,
        QuantityOrdered: 0,
        QuantityShipRec: 0,
        BIN: '',
        Pallet: '',
        UnitPrice: '',
        ImgURL: '',
        RegisterType: '',
        HaveUPC: false,
        DueDate: null
      },

      Totals: {

        OrderDetailtoPick: {
          QuantityOrdered: 0,
          TotalWeight: 0
        },
        OrderDetailPicked: {
          QuantityOrdered: 0,
          QuantityShipRec: 0,
          TotalWeight: 0
        }
      },
      General: temporal,
      PercentageManual: 0,
      PercentageScanning: 0,
      TotalManual: 0,
      TotalScanning: 0
    })
  }

  changeMode() {
    const temp = this.state.General
    if (temp.Mode === 'S/O') {
      temp.Colorclass = 'orange'
      temp.Mode = 'P/O'
      temp.ModeTitle = 'Purchase Order'
    } else {
      temp.Colorclass = 'yellow'
      temp.Mode = 'S/O'
      temp.ModeTitle = 'Sales Order'
    }
    this.setState({ General: temp })
    this.clearAll()
  }

  componentDidMount() {
    //this.setState({ companyPrintHeader: getPrintHeaderCompany() })
  }

  componentWillUnmount() {
    // Clear debounce for search SO
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
  }

  handleModalOpen = (modal) => {
    const temporal = this.state.General
    temporal[modal] = true
    this.setState({ General: temporal })
  }

  handleModalClose = (modal) => {
    const temporal = this.state.General
    temporal[modal] = false
    this.setState({ General: temporal })
    if (modal === "showModal2") {
      this.clearCurrentItem()
      const buscador = document.getElementById('PickingSystemSearchUPC')
      if (buscador) {
        setTimeout(() => { buscador.focus(); }, 300);
      }
    }
  }

  async updateInv() {
    const data = {
      idCompany: Number(getValueCookie('CompanyId')),
      company: getValueCookie('Company'),
      idcompany: getValueCookie('CompanyId'),
    }
    const inventM = await getInformationWithData('/Items/get', data);
    this.setState({ Inventory: inventM.data })

  }

  // Hotfix (2026-08-25): CurrentItem.Description now needs longDescription,
  // which /Items/get (Inventory, above) doesn't carry — only
  // /v3/salesorder/catalog has it. That endpoint is paginated (no "get all"
  // mode), so we page through it once, cache the full list in state.Catalog
  // (same reuse pattern as Inventory/updateInv() above), and return it so
  // callers don't have to wait for a second render to read fresh state.
  async fetchCatalogV3() {
    if (this.state.Catalog && this.state.Catalog.length > 0) {
      return this.state.Catalog
    }

    const idCompany = getValueCookie('CompanyId')
    const pageSize = 200
    const MAX_PAGES = 500 // safety cap: never loop forever on a backend quirk
    let allItems = []
    let page = 1
    let complete = false // did we reach a real end (empty/short page or total), not an error break?

    while (page <= MAX_PAGES) {
      const resp = await getInformationWithDataV3('/v3/salesorder/catalog', { idCompany, page, pageSize })
      if (!resp || !resp.status || resp.status.code !== 1 || !Array.isArray(resp.data)) {
        // Request failed mid-pagination (network hiccup, expired token,
        // etc.) — stop, but do NOT mark complete, so we don't cache a
        // partial catalog below.
        break
      }
      if (resp.data.length === 0) {
        complete = true
        break
      }
      allItems = allItems.concat(resp.data)
      const total = Number(resp.total)
      if (resp.data.length < pageSize || (!isNaN(total) && allItems.length >= total)) {
        complete = true
        break
      }
      page++
    }

    // Only cache when the full catalog was paged through successfully. The
    // guard at the top of this function skips re-fetching once
    // state.Catalog is non-empty, so caching a partial list here (e.g. only
    // 4 of 10 pages, because page 5 failed) would strand the rest of the
    // catalog missing for the whole session — the next PickItem/order load
    // would see Catalog.length > 0 and never retry. On an incomplete run we
    // still return what we got so this one call isn't wasted, but we leave
    // state.Catalog untouched so the next call starts over.
    if (complete) {
      this.setState({ Catalog: allItems })
    }
    return allItems
  }

  async getActualOrders() {
    // Search button/input can fire this multiple times before the first
    // call finishes (double click, impatient re-click). Extra calls just
    // duplicate every request below (header fetch, updateInv, catalog
    // pagination) racing each other. One flight at a time; re-enabled in
    // the finally below once this call is done, error or not.
    if (this.state.loadingOrders) return
    this.setState({ loadingOrders: true })
    try {
      await this.handleModalOpen("showModal1")
      this.ModalLoading.current.showState(true);
      if (this.state.Inventory.length === 0) {
        await this.updateInv()
      }
      // Same reuse pattern as Inventory above — fetchCatalogV3() already
      // no-ops if state.Catalog is populated, so this is only a real request
      // the first time an order is opened. Needed here (not just in PickItem)
      // so the picking/picked-up list rows can show longDescription too.
      // Deliberately NOT awaited: this modal only lists order headers (no
      // item descriptions), so there's no reason to block it on a
      // potentially multi-page catalog fetch — it keeps loading in the
      // background and the tables pick it up on their own once state.Catalog
      // updates (see getItemLongDescription()).
      this.fetchCatalogV3()


      const data = {
      idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
      idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
      SalespersonNo: getValueCookie('SalesPerson'),
      Module: 'Picking'
    }
    const data2 = {
      idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
      idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
      SalespersonNo: '0000'
    }
    var proccessInformation = []

    if (this.state.General.Mode === 'S/O') {
      const respuesta = await getInformationWithData('/sales/get/header', data);
      const completeList = await getInformationWithData('/sales/get/header/byDate', data2);


      if (respuesta.status.code === 1) {

        proccessInformation = respuesta.data.map((element) => {
          const pos = getIndexElement(completeList.data, 'SalesOrderNo', element.SalesOrderNo)

          return {
            Status: element.Status ? element.Status : 0,
            OrderNo: element.Comment ? element.SalesOrderNo + '-' + element.Comment : element.SalesOrderNo,
            OrderName: element.BillToName,
            Date: element.DateUpdated,
            DateTime: decimalToHour(element.TimeCreated),
            SalesPerson: element.SalespersonNo,
            OrderNameAddress: element.BillToAddress1,
            OrderNameCity: element.BillToCity,
            OrderNameNo: element.CustomerNo,
            PriceLevel: element.PriceLevel,
            OrderType: element.OrderType,
            Packing: element.Packing,
            PosQue: pos !== -1 ? (completeList.data[pos].posicion ? (completeList.data[pos].posicion) : 999) : 999
          }
        })
      }

      this.setState({ OrderHeaderList: proccessInformation, filteredOrderList: [...proccessInformation] });

    } else if (this.state.General.Mode === 'P/O') {
      const result = await getInformationWithData('/picklist/get/purchaseOrderHeader', data)

      if (result.status.code === 1) {


        proccessInformation = result.data.map((element) => {
          return {
            Status: element.Status,
            OrderNo: element.Comment !== '' && this.state.General.Mode === 'P/O' ? element.OrderNo + '-' + element.Comment : element.OrderNo,
            OrderName: element.OrderName,
            Date: element.Date,
            SalesPerson: element.SalesPerson,
            OrderNameAddress: element.Address,
            OrderNameCity: element.City,
            OrderNameNo: element.OrderNameNo,
            completionDate: element.completionDate
          }
        }

        )
        this.setState({ OrderHeaderList: proccessInformation, filteredOrderList: [...proccessInformation] });
      }
    }
    this.ModalLoading.current.showState(false);
    } finally {
      // Always releases the lock — including on an unexpected error above —
      // so the Search button never gets stuck disabled.
      this.setState({ loadingOrders: false })
    }
  }

  QueueSalesOrder(allInfo) {

  }

  // Get SO from backend and after load it in the UI
  async SelectOrderByNotification(notification) {
    const orderNo = notification.sales_order_no;

    // Verify changes in products
    const changedSOItems = JSON.parse(notification.changed_items_json || '[]');
    this.setState({ changedSOItems: changedSOItems });
    // console.log(" - CHANGED SO - ");
    // console.log(changedSOItems);
    // console.log(" - CHANGED SO - ");

    // Set SO data
    const idCompany = Number(getValueCookie('CompanyId'));
    try {
      // Make request
      const res = await axios.post(`${server.url}/sales/get/header/by-no`, {
        data: { idCompany: idCompany, SalesOrderNo: orderNo, Module: 'Picking' }
      });

      if (res.data.status.code === 1) {
        let proccessInformation = [];
        const orders = res.data.data;
        // Append extra data
        proccessInformation = orders.map((element) => {
          return {
            Status: element.Status ? element.Status : 0,
            OrderNo: element.Comment ? element.SalesOrderNo + '-' + element.Comment : element.SalesOrderNo,
            OrderName: element.BillToName,
            Date: element.DateUpdated,
            DateTime: decimalToHour(element.TimeCreated),
            SalesPerson: element.SalespersonNo,
            OrderNameAddress: element.BillToAddress1,
            OrderNameCity: element.BillToCity,
            OrderNameNo: element.CustomerNo,
            PriceLevel: element.PriceLevel,
            OrderType: element.OrderType,
            Packing: element.Packing,
            PosQue: 999
          }
        });
        // console.log(proccessInformation);

        // Load SO and update the UI
        if (proccessInformation && proccessInformation.length > 0) {
          this.setState({ ActualHeaderOrder: proccessInformation[0] });
          this.SelectOrdertoPickUp(proccessInformation[0]);
        }
      } else {
        Swal.fire({ title: `Wait`, text: `Order not found`, icon: 'warning', confirmButtonText: 'OK' });
      }
    } catch (error) {
      console.error('Error fetching Sales Order:', error);
      Swal.fire({ title: `Wait`, text: `${error}`, icon: 'warning', confirmButtonText: 'OK' });
    }
  }

  async SelectOrdertoPickUp(order) {
    this.ModalLoading.current.showState(true);
    // Covers the notification path (SelectOrderByNotification calls this
    // directly, skipping getActualOrders()'s prefetch above) — same no-op
    // guard, not awaited for the same reason.
    this.fetchCatalogV3()
    let OrderNo = order.OrderNo.split('-');

    const data = {
      SalesOrderNo: OrderNo[0],
      idCompany: Number(getValueCookie('CompanyId')),
      CustomerNo: order.OrderNameNo,
      username: getValueCookie('userName'),
      company: getValueCookie('Company'),
      idcompany: getValueCookie('CompanyId'),
    }

    if (this.state.General.Mode === 'S/O') {
      const customerInfo = await getInformationWithData('/customer/getByCustomerNo', data);
      const temporal = this.state.ActualHeaderOrder;
      // console.log('Temporal');
      // console.log(temporal);
      // console.log('customerInfo');
      // console.log(customerInfo);

      temporal.Status = order.Status;
      temporal.OrderNo = order.OrderNo;
      temporal.OrderName = order.OrderName + " - Level " + order.PriceLevel;
      temporal.OrderName2 = order.OrderName;
      temporal.OrderNameNo = order.OrderNameNo;
      temporal.OrderNameCity = order.OrderNameCity;
      temporal.Date = order.Date;
      temporal.SalesPerson = order.SalesPerson;
      temporal.OrderNameAddress = order.OrderNameAddress;
      temporal.Order = { ...order };
      temporal.Packing = order.Packing
      if (customerInfo.status.code === 1) {
        temporal.ZipCode = customerInfo.data[0].ZipCode || ''
        temporal.State = await this.getCustomerInfo('State', order.OrderNameNo)
      }
      this.setState({ ActualHeaderOrder: temporal })


      order.OrderNo = OrderNo[0];
      order.idCompany = Number(getValueCookie('CompanyId'));
      order.Mode = false
      if (!(order.Status)) {

        order.Status = 0
      }
      let result = null
      if (getValueCookie('CompanyId') !== '6') {
        result = await getInformationWithData('/sales/get/detail', order);
      } else {
        result = await getInformationWithData('/sales/get/detail/pickingAltitude', order);
      }
      if (result.status.code === 1) {
        await result.data.Tabla1.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }
          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
        });

        await result.data.Tabla2.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }

          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
        });

        // Set colors to modified products
        const enrichedItems = result.data.Tabla1.map(item => {
          const matchedChange = (this.state.changedSOItems || []).find(c => c.ItemCode === item.ItemCode);
          return {
            ...item,
            change_type: matchedChange ? matchedChange.change_type : null
          };
        });

        this.setState({ OrderDetailtoPick: enrichedItems, OrderDetailPicked: result.data.Tabla2 })
        // this.setState({ OrderDetailtoPick: result.data.Tabla1, OrderDetailPicked: result.data.Tabla2 })
        this.calculateTotals()
      } else {
        this.setState({ OrderDetailtoPick: [], OrderDetailPicked: [] })
      }
    } else if (this.state.General.Mode === 'P/O') {
      const result2 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)
      //const result3 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)

      if (result2.status.code === 1) {

        const temporal = this.state.ActualHeaderOrder
        temporal.Status = order.Status
        temporal.OrderNo = order.OrderNo
        temporal.OrderName = order.OrderName
        temporal.OrderName2 = order.OrderName
        temporal.OrderNameNo = order.OrderNameNo
        temporal.OrderNameCity = order.OrderNameCity
        temporal.Date = order.Date
        temporal.SalesPerson = order.SalesPerson
        temporal.OrderNameAddress = order.OrderNameAddress
        temporal.Order = order
        temporal.Packing = ''
        this.setState({ ActualHeaderOrder: temporal })
        await result2.data.Tabla1.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }
          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
        });

        await result2.data.Tabla2.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }

          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
          element.receivedDate = FormatQueryReturnDateForReport(element.receivedDate)
        });

        this.setState({ OrderDetailtoPick: result2.data.Tabla1, OrderDetailPicked: result2.data.Tabla2 })
        this.calculateTotals();
      }
    }

    // Hide customer panel 
    // let instance = this;
    // setTimeout(() => {
    //     instance.setState({showCustomerTab: false});
    // }, 2000);

    this.calculatePercentageScanning()
    this.handleModalClose("showModal1")
    this.ModalLoading.current.showState(false);
  }


  async UpdateOrderDetail(order, customerNo) {
    this.ModalLoading.current.showState(true);
    let OrderNo = order
    const data = {
      SalesOrderNo: OrderNo,
      idCompany: Number(getValueCookie('CompanyId')),
      CustomerNo: customerNo,
      username: getValueCookie('userName'),
      company: getValueCookie('Company'),
      idcompany: getValueCookie('CompanyId'),

    }




    if (this.state.General.Mode === 'S/O') {
      const customerInfo = await getInformationWithData('/customer/getByCustomerNo', data)
      const temporal = this.state.ActualHeaderOrder
      temporal.Status = order.Status
      temporal.OrderNo = order.OrderNo
      temporal.OrderName = order.OrderName + " - Level " + order.PriceLevel
      temporal.OrderName2 = order.OrderName
      temporal.OrderNameNo = order.OrderNameNo
      temporal.OrderNameCity = order.OrderNameCity
      temporal.Date = order.Date
      temporal.SalesPerson = order.SalesPerson
      temporal.OrderNameAddress = order.OrderNameAddress
      temporal.Order = order
      temporal.Packing = order.Packing
      if (customerInfo.status.code === 1) {
        temporal.ZipCode = customerInfo.data[0].ZipCode
        temporal.State = await this.getCustomerInfo('State', order.OrderNameNo)
      }





      await this.setState({ ActualHeaderOrder: temporal })


      order.OrderNo = OrderNo[0];
      order.idCompany = Number(getValueCookie('CompanyId'));
      order.Mode = false
      if (!(order.Status)) {
        order.Status = 0
      }
      const result = await getInformationWithData('/sales/get/detail', order)

      if (result.status.code === 1) {

        await result.data.Tabla1.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }
          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
        });

        await result.data.Tabla2.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }

          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
        });

        this.setState({ OrderDetailtoPick: result.data.Tabla1, OrderDetailPicked: result.data.Tabla2 })
        this.calculateTotals()
      } else {
        this.setState({ OrderDetailtoPick: [], OrderDetailPicked: [] })
      }



    } else if (this.state.General.Mode === 'P/O') {
      const result2 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)
      //const result3 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)

      if (result2.status.code === 1) {

        const temporal = this.state.ActualHeaderOrder
        temporal.Status = order.Status
        temporal.OrderNo = order.OrderNo
        temporal.OrderName = order.OrderName
        temporal.OrderName2 = order.OrderName
        temporal.OrderNameNo = order.OrderNameNo
        temporal.OrderNameCity = order.OrderNameCity
        temporal.Date = order.Date
        temporal.SalesPerson = order.SalesPerson
        temporal.OrderNameAddress = order.OrderNameAddress
        temporal.Order = order
        temporal.Packing = ''
        this.setState({ ActualHeaderOrder: temporal })
        await result2.data.Tabla1.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }
          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
        });

        await result2.data.Tabla2.forEach(element => {
          const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
          let desc = ''
          if (index !== -1) {
            desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
          }

          if (desc !== '') {
            element.ItemCodeDesc = desc
          }
          element.receivedDate = FormatQueryReturnDateForReport(element.receivedDate)
        });

        this.setState({ OrderDetailtoPick: result2.data.Tabla1, OrderDetailPicked: result2.data.Tabla2 })
        this.calculateTotals()




      }
    }






    this.calculatePercentageScanning()
    this.handleModalClose("showModal1")
    this.ModalLoading.current.showState(false);
  }

  async PickItem(Item, add) {
    // Validate if it was deleted
    if (Item.change_type !== 'deleted') {
      if (Number(this.state.ActualHeaderOrder.Status) !== 2 || this.state.ActualHeaderOrder.SalesPerson !== 'WW') {

        this.handleModalOpen("showModal2")
        const data = {
          ItemCode: Item.ItemCode,
          BIN: Item.BIN,
          company: getValueCookie('Company'),
          idCompany: Number(getValueCookie('CompanyId')),
        }
        const data2 = {
          ItemCode: Item.ItemCode,
          BIN: Item.BIN,
          company: getValueCookie('Company'),
          idCompany: (getValueCookie('CompanyId')),
        }

        const resultquant = await getInformationWithData('/invertory/getQuantity/post', data2)
        const resultImg = await getInformationWithData('/Items/get/Img', data)
        const catalog = await this.fetchCatalogV3()
        if (resultquant.status.code === 1 && resultImg.status.code === 1) {
          var URL = ''
          if (resultImg.status.code === 1) {
            if (resultImg.data[0].itemURLImage && resultImg.data[0].itemURLImage !== '') {
              const date = new Date().getTime()
              URL = `${resultImg.data[0].itemURLImage}?${date}`
            } else {
              URL = null
            }
          }
          let onHand = 0
          if (resultquant.data.length > 0) {
            onHand = resultquant.data[0].Quantity.toFixed(0)
          }

          // longDescription comes from the catalog (CI_Item, via
          // /v3/salesorder/catalog) — inserted alongside the existing SO-line
          // Description, not replacing it. Kept raw (may be null/'' if the
          // item isn't in the catalog) — consumers fall back to Description
          // when longDescription is missing, same fallback pattern
          // buildCartLine.js/buildInvoiceCartLine.js already use.
          const catalogIndex = getIndexElement(catalog, 'itemCode', Item.ItemCode)
          const longDescription = catalogIndex !== -1 ? catalog[catalogIndex].longDescription : ''

          const ItemSelected = {
            ItemCode: Item.ItemCode,
            Description: { Description: Item.ItemCodeDesc, longDescription },
            onHand: onHand,
            QuantityOrdered: Item.QuantityOrdered,
            QuantityShipRec: add ? 1 : 0,
            BIN: Item.BIN,
            Pallet: '01',
            UnitPrice: Item.UnitPrice,
            ImgURL: URL,
            RegisterType: Item.RegisterType ? Item.RegisterType : 'm',
            HaveUPC: ((resultImg.data.upc) || (resultImg.data.upc2) || (resultImg.data.caseupc)) ? true : false,
            DueDate: null
          }

          let input = document.getElementById('quantityShipRecPickingSystem')
          if (input) {
            input.value = ItemSelected.QuantityShipRec > 0 ? ItemSelected.QuantityShipRec : 0
          }



          this.setState({ CurrentItem: ItemSelected })

        }
      } else {
        confirmCloseAlert('incorrect', 'This order are finished, please contact with the Warehouse Admin!')
      }
    }
  }
  // Same fallback used for CurrentItem.Description, applied to the
  // OrderDetailtoPick/OrderDetailPicked rows shown in the Picking List and
  // Picked Up List tables: prefer the catalog's longDescription, fall back
  // to the row's own ItemCodeDesc (from Inventory, see the forEach loops
  // above) when the item isn't in the catalog yet.
  getItemLongDescription(item) {
    const catalogIndex = getIndexElement(this.state.Catalog, 'itemCode', item.ItemCode)
    const longDescription = catalogIndex !== -1 ? this.state.Catalog[catalogIndex].longDescription : ''
    return longDescription || item.ItemCodeDesc
  }
  clearCurrentItem() {
    const ItemSelected = {
      ItemCode: '',
      Description: { Description: '', longDescription: '' },
      onHand: 0,
      QuantityOrdered: 0,
      QuantityShipRec: 0,
      BIN: '',
      Pallet: '01',
      UnitPrice: '',
      ImgURL: '',
      RegisterType: '',
      DueDate: null
    }
    this.setState({ CurrentItem: ItemSelected })
  }
  calculatePercentageScanning() {
    let total = 0

    let manual = 0
    let scanner = 0
    for (const item of this.state.OrderDetailPicked) {

      if (item.QuantityShipped > 0) {
        total += 1
        if (item.RegisterType === 's') {
          scanner += 1
        } else {
          manual += 1
        }
      }

    }
    if (total > 0) {
      let Pmanual = 100 * (manual / total)
      let Pscanning = 100 * (scanner / total)
      this.setState({ TotalManual: manual, TotalScanning: scanner, PercentageManual: Pmanual, PercentageScanning: Pscanning })
    } else {
      this.setState({ TotalManual: 0, TotalScanning: 0, PercentageManual: 0, PercentageScanning: 0 })
    }
  }

  async confirmPickItem() {
    let orderno = this.state.ActualHeaderOrder.OrderNo.split('-')
    const temporal = this.state.CurrentItem
    const index = getIndexElement(this.state.OrderDetailtoPick, "ItemCode", temporal.ItemCode)
    if (index !== -1) {
      const itemToPick = this.state.OrderDetailtoPick[index]

      itemToPick.QuantityShipped = Number(document.getElementById('quantityShipRecPickingSystem').value)
      itemToPick.Pallet = this.state.General.currentPallet
      itemToPick.check = 1
      itemToPick.UserName = getValueCookie('userName')
      itemToPick.receivedDate = FormatQueryReturnDateForReport(getActualDateUTC())
      itemToPick.TotalLineWeight = Number(document.getElementById('quantityShipRecPickingSystem').value) * Number(itemToPick.LineWeight)
      itemToPick.HaveUPC = temporal.HaveUPC
      itemToPick.RegisterType = temporal.RegisterType
      const Table1 = this.state.OrderDetailtoPick
      const Table2 = this.state.OrderDetailPicked


      const data = {
        OrderNo: orderno[0],
        IdCompany: Number(getValueCookie('CompanyId')),
        ItemCode: itemToPick.ItemCode,
        QuantityRecived: Number(document.getElementById('quantityShipRecPickingSystem').value),
        QuantityShipped: Number(document.getElementById('quantityShipRecPickingSystem').value),
        Pallet: document.getElementById('palletPickingSystem').value,
        User: getValueCookie('userName'),
        DispatchDate: getActualDateUTC(),
        check: 1,
        Mode: this.state.General.Mode,
        QuantityOrdered: temporal.QuantityOrdered,
        UnitPrice: temporal.UnitPrice,
        UnitCost: itemToPick.LastTotalUnitCost,
        ItemCodeDesc: DeleteStrangeCharacter(itemToPick.ItemCodeDesc),
        LineWeight: itemToPick.LineWeight,
        RegisterType: temporal.RegisterType,
        HaveUPC: temporal.HaveUPC,
        DueDate: temporal.DueDate ? this.formatDate(temporal.DueDate) : temporal.DueDate
      }
      if (this.state.General.Mode === 'S/O') {
        if (data.QuantityShipped > 0 && !data.HaveUPC) {
          data.RegisterType = 's'
          itemToPick.RegisterType = 's'
        }
      } else {
        if (data.QuantityRecived > 0 && !data.HaveUPC) {
          data.RegisterType = 's'
          itemToPick.RegisterType = 's'
        }
      }


      if ((this.state.CurrentItem.DueDate || data.QuantityRecived === 0) || this.state.General.Mode === 'S/O') {
        const result = await create_Delete_Update_Information('/picklist/set/dispatchItem', data)

        if (result.status.code !== 1) {
          await this.handleModalClose("showModal2");
          await confirmCloseAlert('incorrect', 'Whoops we have an error. Please try again!');
          await this.SelectOrdertoPickUp(this.state.ActualHeaderOrder.Order);

        } else {
          Table1.splice(index, 1)
          Table2.push(itemToPick)
          this.setState({ OrderDetailPicked: Table2, OrderDetailtoPick: Table1 })
          await this.handleModalClose("showModal2")

        }
      } else {
        confirmCloseAlert('incorrect', 'You need put the Fecha de Vencimiento!')
      }



    } else {

      const newItem = {
        BIN: this.state.CurrentItem.BIN,
        CASEUPC: 0,
        CommetText: '',
        ItemCode: this.state.CurrentItem.ItemCode,
        ItemCodeDesc: this.state.CurrentItem.Description.longDescription || this.state.CurrentItem.Description.Description,
        LineSeqNo: 0,
        LineWeight: '',
        OrderNo: orderno[0],
        Pallet: document.getElementById('palletPickingSystem').value,
        QuantityOrdered: 0,
        QuantityShipped: Number(document.getElementById('quantityShipRecPickingSystem').value),
        UPC: '',
        caseupc: 0,
        check: 1,
        RegisterType: this.state.CurrentItem.RegisterType,
        HaveUPC: this.state.CurrentItem.HaveUPC,
        DueDate: this.state.CurrentItem.DueDate
      }
      if (this.state.General.Mode === 'S/O') {
        if (newItem.QuantityShipped > 0 && !newItem.HaveUPC) {
          newItem.RegisterType = 's'
        }
      } else {
        if (newItem.QuantityRecived > 0 && !newItem.HaveUPC) {
          newItem.RegisterType = 's'
        }
      }

      const Table2 = this.state.OrderDetailPicked
      Table2.push(newItem)
      this.setState({ OrderDetailPicked: Table2 })
      this.handleModalClose("showModal2")
    }


    this.calculateTotals()
    this.calculatePercentageScanning()
    const buscador = document.getElementById('PickingSystemSearchUPC')
    if (buscador) {
      setTimeout(() => { buscador.focus(); }, 300);
    }

  }

  async RemoveProductPickedList(temporal) {

    if (Number(this.state.ActualHeaderOrder.Status) !== 2 || this.state.ActualHeaderOrder.SalesPerson !== 'WW') {
      Swal.fire({
        title: 'Are you sure?',
        text: "You are removing a product to the Picked Up List",
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove',
        cancelButtonText: 'No, cancel!',
      }).then(async (result) => {
        if (result.isConfirmed) {


          const index = getIndexElement(this.state.OrderDetailPicked, "ItemCode", temporal.ItemCode)
          if (index !== -1) {

            const itemToPick = this.state.OrderDetailPicked[index]

            itemToPick.QuantityShipped = 0
            itemToPick.Pallet = '01'
            itemToPick.check = 0
            itemToPick.HaveUPC = false
            itemToPick.RegisterType = ''
            const Table1 = this.state.OrderDetailtoPick
            const Table2 = this.state.OrderDetailPicked
            Table2.splice(index, 1)
            Table1.push(itemToPick)
            this.setState({ OrderDetailPicked: Table2, OrderDetailtoPick: Table1 })
            if (this.state.General.Mode === 'S/O') {
              const data = {
                OrderNo: temporal.SalesOrderNo,
                ItemCode: itemToPick.ItemCode,
                QuantityRecived: 0,
                Pallet: '',
                User: '',
                DispatchDate: new Date(),
                check: 0,
                Mode: this.state.General.Mode,
              }
              await create_Delete_Update_Information('/picklist/set/dispatchItem', data)
            } else {
              let orderno = this.state.ActualHeaderOrder.OrderNo.split('-')
              const data = {
                OrderNo: temporal.OrderNo ? temporal.OrderNo : orderno[0],
                ItemCode: itemToPick.ItemCode,
                QuantityRecived: 0,
                Pallet: '01',
                User: '',
                DispatchDate: '000-00-00 00:00:00',
                check: 0,
                Mode: this.state.General.Mode,
              }

              await create_Delete_Update_Information('/picklist/set/dispatchItem', data)
            }




          }
          this.calculateTotals()
        }
      })
    } else {
      confirmCloseAlert('incorrect', 'This order are finished, please contact with the Warehouse Admin!')
    }

  }
  print() {

  }

  clearTotals() {
    const temporal = this.state.Totals
    temporal.OrderDetailtoPick.QuantityOrdered = 0
    temporal.OrderDetailtoPick.TotalWeight = 0

    temporal.OrderDetailPicked.QuantityOrdered = 0
    temporal.OrderDetailPicked.QuantityShipRec = 0
    temporal.OrderDetailPicked.TotalWeight = 0

    this.setState({ Totals: temporal })
  }

  calculateTotals() {
    const temporal = this.state.Totals
    this.clearTotals()
    for (const item of this.state.OrderDetailtoPick) {

      temporal.OrderDetailtoPick.QuantityOrdered += Number(item.QuantityOrdered)
      temporal.OrderDetailtoPick.TotalWeight += Number(item.QuantityOrdered) * Number(item.LineWeight)


    }
    for (const item of this.state.OrderDetailPicked) {
      if (item.Pallet !== -1) {
        if (item.LineSeqNo || this.state.General.Mode === 'P/O') {
          temporal.OrderDetailPicked.QuantityOrdered += Number(item.QuantityOrdered)
          temporal.OrderDetailPicked.QuantityShipRec += Number(item.QuantityShipped)
          temporal.OrderDetailPicked.TotalWeight += Number(item.QuantityShipped) * Number(item.LineWeight)
        }
      }
    }
    this.setState({ Totals: temporal })
  }

  confirmCompletePick() {
    Swal.fire({
      title: 'Are you sure to complete this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, I\'m sure!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let orderno = this.state.ActualHeaderOrder.OrderNo.split('-')
        if (this.state.General.Mode === 'P/O') {
          await this.UpdateOrderDetail(orderno, this.state.ActualHeaderOrder.OrderNameNo)
        }

        this.calculatePercentageScanning()

        const data = {
          OrderNo: orderno[0],
          Status: '2',
          idCompany: getValueCookie('CompanyId'),
          MODE: this.state.General.Mode
        }
        const resultSql = await create_Delete_Update_Information('/picklist/set/PickListState', data)
        await getInformationWithDataGlobalSales('/Sales/setStatus', { SalesOrderNo: data.OrderNo, OrderStatus: 6 })
        if (resultSql.code === 1) {
          const temporal = this.state.ActualHeaderOrder
          temporal.Status = '2'
          this.setState({ ActualHeaderOrder: temporal })
          Swal.fire({
            title: 'Order Completed!',
            html: `
                        <div className='tableFixHead'>
                        <table className='table align-middle'>
                        <thead className='thead'>
                            <tr className='text-light text-center'>
                                <th className='bg-dark'>Type</th>
                                <th className='bg-dark'>Quantity</th>
                                <th className='bg-dark'>Percentage</th>
                            </tr>
                        </thead>
                        <tbody className='tbody'>
                            <tr>
                            <td>Scanned Products</td>
                            <td>${this.state.TotalScanning}</td>
                            <td className='text-end'>${pricesFormat(this.state.PercentageScanning)} %</td>
                            </tr>
                            <tr>
                            <td>Manual Products</td>
                            <td>${this.state.TotalManual}</td>
                            <td className='text-end'>${pricesFormat(this.state.PercentageManual)}%</td>
                            </tr>
                        </tbody>
                        <tfoot className='tfoot'>
                        <tr className='bg-secondary text-light'>
                        <td>Total</td>
                        <td>${this.state.TotalManual + this.state.TotalScanning}</td>
                        <td>${100} %</td>
                        </tr>
                        </tfoot>
                    </table>
                            </div>
                            <div className=''>
                        <p>The order was registered.\nWould you like print it?</p>
                        </div>
                            `,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, please!',
            cancelButtonText: 'No thanks'
          }
          ).then((result) => {
            if (result.isConfirmed) {
              var button = document.getElementById('PrintPickOrder')
              if (button) {
                button.click()
              }
            } else {
              this.clearAll()
            }
          })
        }


      }
    })
  }

  stateInWords(state) {

    if (this.state.General.Mode === 'P/O') {
      if (state === '1') {
        return 'Pending Order'
      } else if (state === '2') {
        return 'Order Completed'
      } else {
        return ''
      }
    } else {
      if (state === 1) {
        return 'In process'
      } else if (state === 2) {
        return 'Finished'
      } else {
        return 'Not started'
      }
    }



  }
  stateClassColor(state) {
    if (this.state.General.Mode === 'P/O') {
      if (state === '1') {
        return 'yellow'
      } else if (state === '2') {
        return 'green'
      } else {
        return ''
      }
    } else {
      if (state === 1) {
        return 'yellow'
      } else if (state === 2) {
        return 'green'
      } else {
        return 'red'
      }
    }
  }

  statusIcon(state, mode) {
    const normalizedMode = mode || '';

    if (normalizedMode === 'P/O') {
      if (state === '1') {
        return <AiOutlineClockCircle color="#212121" title="Process" />;
      } else if (state === '2') {
        return <AiOutlineCheckCircle color="#fff" title="Finished" />;
      } else {
        return null;
      }
    } else {
      if (state === 1) {
        return <AiOutlineClockCircle color="#212121" title="Process" />;
      } else if (state === 2) {
        return <AiOutlineCheckCircle color="#fff" title="Finished" />;
      } else {
        return <AiOutlineCloseCircle color="#fff" title="Not started" />;
      }
    }
  }

  formatDatePickedUp() {
    let temporal = []
    let copy = JSON.parse(JSON.stringify(this.state.OrderDetailPicked))
    copy.forEach(element => {
      // LONGDESC-2026-09-30 (client's ask, escalated by the owner) — the
      // on-screen picking list already resolves this via
      // getItemLongDescription() (see lines ~1555/1613), but the printed PDF
      // ("Print Order") built from this array never did, so the bodega crew's
      // paper sheet still showed the short ItemCodeDesc. Same helper, same
      // fallback order (longDescription > ItemCodeDesc).
      element.ItemCodeDesc = this.getItemLongDescription(element)
      element.receivedDate2 = element.receivedDate
      element.QuantityOrdered = NumberFormat(pricesFormat(element.QuantityOrdered))
      element.QuantityShipped = NumberFormat(pricesFormat(element.QuantityShipped))
      element.LineWeight = NumberFormat(pricesFormat(Number(element.LineWeight)))
      element.TotalLineWeight = Number(element.TotalLineWeight)
      if (element.Pallet !== -1) {
        if (element.LineSeqNo) {
          temporal.push(element)
        }

      }

    });
    return temporal
  }

  ordenar(arreglo, llave, bandera) {

    const l = arreglo.length;
    if (bandera) {
      for (let i = 0; i < l; i++) {
        for (let j = 0; j < l - 1 - i; j++) {
          if (arreglo[j][llave] > arreglo[j + 1][llave]) {
            [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
          }
        }
      }
    } else {
      for (let i = 0; i < l; i++) {
        for (let j = 0; j < l - 1 - i; j++) {
          if (arreglo[j][llave] < arreglo[j + 1][llave]) {
            [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
          }
        }
      }
    }
    return arreglo;
  }


  arreglarLista(llave) {
    let pick = this.state.OrderDetailtoPick
    pick = this.ordenar(pick, llave, this.state.bandera);
    this.setState({ bandera: !this.state.bandera });
    this.setState({ OrderDetailtoPick: pick });
  }

  arreglarLista2(llave) {
    let pick = this.state.OrderDetailPicked
    pick = this.ordenar(pick, llave, this.state.bandera);
    this.setState({ bandera: !this.state.bandera });
    this.setState({ OrderDetailPicked: pick });
  }

  onTarget = e => {
    const id = e.target.id
    if (id === 'palletPickingSystem') {
      const temporal = this.state.General
      temporal.currentPallet = e.target.value
      this.setState({ General: temporal })
    }
  }

  async getCustomerInfo(key, customerNo) {
    const data = {
      idCompany: Number(getValueCookie('CompanyId')),
      CustomerNo: customerNo,
    }
    const result = await getInformationWithData('/customer/getByCustomerNo', data);
    if (result.status.code === 1) {
      if (result.data.length > 0) {
        return result.data[0][key]
      }
    }
    return ''
  }

  // Order for columns SO modal
  GeneralOrder(key, asc, name) {
    const temporal = this.state[name]
    const Order = OrderArray(temporal, key, asc)

    this.setState({ [name]: Order, order: !asc })
  }

  changeInputShipped = (e) => {
    let quant = Number(e.target.value)

    if (!validateNumbersForQuantitys(quant)) {
      let parteDecimal = 1 - DecimalPart(quant)
      quant += parteDecimal
      document.getElementById(e.target.id).value = quant
    }
  }
  changeDueDate = (e) => {
    const temporal = this.state.CurrentItem
    let date = new Date(e.target.value)
    temporal.DueDate = new Date(date.setMinutes(date.getMinutes() + date.getTimezoneOffset()))
  }
  formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  handleSearchOrders = () => {
    const pattern = this.state.searchText.trim();
    if (!pattern) {
      // Vacío = mostrar todo
      this.setState({ filteredOrderList: [...this.state.OrderHeaderList] });
      return;
    }

    try {
      const regex = new RegExp(pattern, 'i');

      const filtered = this.state.OrderHeaderList.filter(order =>
        regex.test(order.OrderNo) ||
        regex.test(order.OrderName) ||
        regex.test(order.SalesPerson)
      );

      this.setState({ filteredOrderList: filtered });
    } catch (e) {
      console.warn("Expresión inválida:", pattern);
      // Si el regex falla, no hacer nada
    }
  };

  // Modal SO search
  handleSearchInput = (value) => {
    // Set value
    this.setState({ searchText: value });
    // Clear timer
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    // Wait for stop writting
    this.searchTimeout = setTimeout(() => {
      this.handleSearchOrders(); // tu función actual
    }, 500); // Espera 500 ms desde la última tecla
  };

  render() {
    const mode = this.state.General.Mode
    const hasOrder = !!(this.state.ActualHeaderOrder && this.state.ActualHeaderOrder.OrderName)
    const sortArrows = <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
    const changeTypeClass = (ct) => {
      if (ct === 'added') return 'status-success'
      if (ct === 'modified') return 'status-warning'
      if (ct === 'deleted') return 'status-danger'
      return ''
    }
    const modalRowClass = (status) => {
      if (mode === 'P/O') {
        if (status === '1') return 'status-warning'
        if (status === '2') return 'status-success'
        return ''
      }
      if (status === 1) return 'status-warning'
      if (status === 2) return 'status-success'
      return 'status-danger'
    }
    const itemBadge = (val) => (
      <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{val}</span>
    )

    return (
      <div className="dash-page" style={{ paddingTop: '70px' }}>
        <Menu Refresh={this.state.Refresh} Father={this} />
        <LoadingWindow ref={this.ModalLoading} />
        <NotificationBell openSO={this.SelectOrderByNotification.bind(this)} selectedSO={this.state.ActualHeaderOrder} />

        {/* Hero */}
        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
            <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
          </div>
          <div style={{ flex: 1 }}>
            <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Warehouse Picking</h1>
            <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
              {hasOrder
                ? `${mode === 'S/O' ? 'Sales Order' : 'Purchase Order'}: ${this.state.ActualHeaderOrder.OrderNo} · ${this.state.ActualHeaderOrder.OrderName}`
                : `${mode === 'S/O' ? 'Sales Order' : 'Purchase Order'} mode — select an order to begin`}
            </p>
          </div>
          <button type="button" onClick={() => this.changeMode()}
            style={{ background: mode === 'S/O' ? 'rgba(139,92,246,0.25)' : 'rgba(37,99,235,0.25)', border: `1px solid ${mode === 'S/O' ? 'rgba(139,92,246,0.5)' : 'rgba(37,99,235,0.5)'}`, borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1.25rem', fontSize: '0.875rem', cursor: 'pointer' }}>
            {mode} Mode
          </button>
        </div>

        <div style={{ padding: '1.5rem 2rem' }}>

          {/* Search bar */}
          <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0' }}>
            <div className="card-body" style={{ padding: '1rem 1.25rem' }}>
              <div style={{ display: 'flex', gap: '0.625rem', alignItems: 'center' }}>
                <input type="text" autoComplete='off'
                  className="form-control form-control-lg"
                  style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', fontWeight: 600, flex: 1 }}
                  disabled value={this.state.ActualHeaderOrder.OrderNo}
                  id='OrderNoPickingSystem'
                  onClick={() => this.getActualOrders()}
                  placeholder="Select a sales order..." />
                <button type="button" disabled={this.state.loadingOrders} onClick={() => this.getActualOrders()}
                  style={{ background: 'linear-gradient(135deg, #1e40af, #2563EB)', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.75rem 1.5rem', fontSize: '1rem', cursor: this.state.loadingOrders ? 'not-allowed' : 'pointer', opacity: this.state.loadingOrders ? 0.65 : 1, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '0.4rem', height: '3rem' }}>
                  <AiOutlineSearch /> {this.state.loadingOrders ? 'Searching…' : 'Search'}
                </button>
              </div>
            </div>
          </div>

          {/* Customer card — expanded */}
          {hasOrder && this.state.showCustomerTab && (
            <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>Customer</span>
                <button type="button" onClick={() => this.setState({ showCustomerTab: false })}
                  style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px', color: 'white', padding: '0.2rem 0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <AiOutlineMinusSquare size={16} />
                </button>
              </div>
              <div style={{ padding: '1.25rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem', marginBottom: '1rem' }}>
                  <div className="pol-kv-box">
                    <span>Customer Name</span>
                    <strong>{this.state.ActualHeaderOrder.OrderName.replace('null', '')}</strong>
                  </div>
                  <div className="pol-kv-box">
                    <span>Sales Person</span>
                    <strong>{this.state.ActualHeaderOrder.SalesPerson || '—'}</strong>
                  </div>
                  {mode !== 'P/O' && (
                    <div className="pol-kv-box">
                      <span>Type of Packing</span>
                      <strong>{ReplaceCharacter(this.state.ActualHeaderOrder.Packing && this.state.ActualHeaderOrder.Packing !== 'null;null' ? this.state.ActualHeaderOrder.Packing : '', ';', ' ') || '—'}</strong>
                    </div>
                  )}
                </div>
                <div>
                  <label style={{ fontSize: '0.78rem', color: '#64748B', fontWeight: 600, marginBottom: '0.3rem', display: 'block' }}>Comment</label>
                  <textarea
                    disabled={this.state.ActualHeaderOrder.OrderNo === '' || this.state.ActualHeaderOrder.Status === '2'}
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    placeholder='Insert comment...'
                    rows="2"
                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem' }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Customer card — collapsed */}
          {hasOrder && !this.state.showCustomerTab && (
            <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0' }}>
              <div style={{ padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
                  <span style={{ fontWeight: 700, color: '#334155', fontSize: '0.875rem' }}>Customer</span>
                  <span style={{ fontSize: '0.875rem', color: '#64748B' }}>{this.state.ActualHeaderOrder.OrderName.replace('null', '')}</span>
                </div>
                <button type="button" onClick={() => this.setState({ showCustomerTab: true })}
                  style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '6px', color: '#2563EB', padding: '0.2rem 0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <AiOutlineZoomIn size={16} />
                </button>
              </div>
            </div>
          )}

          {/* Picking List */}
          {hasOrder && (
            <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>Picking List — {this.state.General.ModeTitle}</span>
              </div>
              {/* Catalogue + UPC search */}
              <div style={{ padding: '0.875rem 1.25rem', borderBottom: '1px solid #E2E8F0' }}>
                <div hidden={mode === 'S/O'}>
                  <Catalogue Array={'OrderDetailtoPick'} disabled={this.state.ActualHeaderOrder.Status === '2'} nombrePadre={"PickingSystem"} Padre={this} />
                </div>
                <SearchUPC id={"PickingSystemSearchUPC"} ComponentName={'PickingSystem'} Padre={this} />
              </div>
              <div className="tableFixHeadSmall">
                <table className="table table-clean mb-0">
                  <thead>
                    <tr className="text-center">
                      <th hidden onClick={() => this.arreglarLista('LineSeqNo')}>Line Key</th>
                      <th onClick={() => this.arreglarLista('ItemCode')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                      <th className="text-start">Description</th>
                      <th onClick={() => this.arreglarLista('QuantityOrdered')} style={{ cursor: 'pointer' }}>Qty Ordered {sortArrows}</th>
                      <th onClick={() => this.arreglarLista('LineWeight')} style={{ cursor: 'pointer' }}>Weight {sortArrows}</th>
                      <th onClick={() => this.arreglarLista('TotalWeight')} style={{ cursor: 'pointer' }}>Total Weight {sortArrows}</th>
                      <th hidden>BIN</th>
                      <th className="text-start">Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.OrderDetailtoPick.map((item, i) => (
                      <tr key={i} className={changeTypeClass(item.change_type)} onClick={() => this.PickItem(item, false)} style={{ cursor: 'pointer' }}>
                        <td hidden>{item.LineSeqNo}</td>
                        <td>{itemBadge(item.ItemCode)}</td>
                        <td className="text-start">
                          {this.getItemLongDescription(item)}
                          {item.change_type === 'deleted' && (
                            <span style={{ marginLeft: '0.5rem', background: 'rgba(239,68,68,0.1)', color: '#DC2626', border: '1px solid #FECACA', borderRadius: '6px', padding: '1px 6px', fontSize: '0.7rem', fontWeight: 700 }}>deleted</span>
                          )}
                        </td>
                        <td className="text-center" style={{ fontWeight: 600 }}>{item.QuantityOrdered}</td>
                        <td className="text-center">{item.LineWeight}</td>
                        <td className="text-center">{item.TotalWeight ? item.TotalWeight : Number(item.LineWeight) * Number(item.QuantityOrdered)}</td>
                        <td hidden>{item.BIN}</td>
                        <td className="text-start" style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.CommentText}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="tfoot">
                    <tr>
                      <td></td>
                      <td style={{ fontWeight: 700 }}>Totals</td>
                      <td className="text-center" style={{ fontWeight: 700 }}>{this.state.Totals.OrderDetailtoPick.QuantityOrdered}</td>
                      <td></td>
                      <td className="text-center" style={{ fontWeight: 700 }}>{this.state.Totals.OrderDetailtoPick.TotalWeight.toFixed(2)}</td>
                      <td hidden></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}

          {/* Picked Up List */}
          {hasOrder && (
            <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>Picked Up List</span>
              </div>
              <div className="tableFixHeadSmall">
                <table className="table table-clean mb-0">
                  <thead>
                    <tr className="text-center">
                      <th onClick={() => this.arreglarLista2('LineSeqNo')} style={{ cursor: 'pointer' }}>Line Seq. {sortArrows}</th>
                      <th onClick={() => this.arreglarLista2('ItemCode')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                      <th className="text-start">Description</th>
                      <th onClick={() => this.arreglarLista2('QuantityOrdered')} style={{ cursor: 'pointer' }}>Qty Ordered {sortArrows}</th>
                      <th onClick={() => this.arreglarLista2('QuantityShipped')} style={{ cursor: 'pointer' }}>{mode === 'S/O' ? 'Qty Shipped' : 'Qty Received'} {sortArrows}</th>
                      <th onClick={() => this.arreglarLista2('LineWeight')} style={{ cursor: 'pointer' }}>Weight {sortArrows}</th>
                      <th onClick={() => this.arreglarLista2('TotalLineWeight')} style={{ cursor: 'pointer' }}>Total Weight {sortArrows}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.OrderDetailPicked.map((item, i) => (
                      <tr key={i}
                        hidden={mode === 'S/O' && (item.Pallet === -1 || (!item.LineSeqNo))}
                        onClick={() => this.RemoveProductPickedList(item)}
                        className="status-success"
                        style={{ cursor: 'pointer' }}>
                        <td>{itemBadge(item.LineSeqNo)}</td>
                        <td style={{ fontWeight: 600, color: '#334155' }}>{item.ItemCode}</td>
                        <td className="text-start">
                          {this.getItemLongDescription(item)}
                          {item.CommentText && (
                            <div style={{ fontSize: '0.78rem', color: '#64748B', marginTop: '2px' }}>💬 {item.CommentText}</div>
                          )}
                        </td>
                        <td className="text-center">{NumberFormat(pricesFormat(item.QuantityOrdered))}</td>
                        <td className="text-center" style={{ fontWeight: 700, color: '#059669' }}>{NumberFormat(pricesFormat(item.QuantityShipped))}</td>
                        <td className="text-center">{NumberFormat(pricesFormat(item.LineWeight))}</td>
                        <td className="text-center">{NumberFormat(pricesFormat(item.TotalLineWeight))}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="tfoot">
                    <tr>
                      <td></td>
                      <td></td>
                      <td style={{ fontWeight: 700 }}>Totals</td>
                      <td className="text-center" style={{ fontWeight: 700 }}>{NumberFormat(this.state.Totals.OrderDetailPicked.QuantityOrdered)}</td>
                      <td className="text-center" style={{ fontWeight: 700, color: '#059669' }}>{NumberFormat(this.state.Totals.OrderDetailPicked.QuantityShipRec)}</td>
                      <td></td>
                      <td className="text-center" style={{ fontWeight: 700 }}>{NumberFormat(pricesFormat(this.state.Totals.OrderDetailPicked.TotalWeight))}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Action buttons */}
              <div style={{ padding: '1rem 1.25rem', borderTop: '1px solid #E2E8F0', display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', flexWrap: 'wrap', alignItems: 'center' }}>
                <button type="button"
                  disabled={this.state.ActualHeaderOrder.Status === 2 || this.state.ActualHeaderOrder.Status === '2' || this.state.ActualHeaderOrder.Status === ''}
                  onClick={() => this.confirmCompletePick()}
                  style={{ background: 'linear-gradient(135deg, #1e40af, #2563EB)', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.55rem 1.25rem', fontSize: '0.9rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                  <AiTwotoneSave /> Finish Order
                </button>
                {MobileDisp() ? (
                  <OrderPDF
                    id={"PrintPickOrder"} disabled={this.state.ActualHeaderOrder.Status === ''} colorButton="greenButton" title="Print Order"
                    companyLogo={getValueCookie('DocumentsLogo')}
                    OrderTitle="Picked Up List"
                    contactInfo={this.state.companyPrintHeader}
                    OrderInfo1={["Order No: ", this.state.ActualHeaderOrder.OrderNo, "Order by: ", this.state.ActualHeaderOrder.SalesPerson, "No Vendor: ", this.state.ActualHeaderOrder.OrderNameNo, "Printed by: ", getValueCookie('userName'), "Vendor: ", this.state.ActualHeaderOrder.OrderName2, "Printed Date: ", FormatQueryReturnDateForReport(getActualDateUTC()), "Date: ", (formatInputDateQuery(this.state.ActualHeaderOrder.Date) !== "" ? formatInputDateQuery(this.state.ActualHeaderOrder.Date) : DateFormatMAS90(this.state.ActualHeaderOrder.Date)), this.state.ActualHeaderOrder.ZipCode !== '' ? "Address:" : "", `${this.state.ActualHeaderOrder.OrderNameAddress}, ${this.state.ActualHeaderOrder.State}, ${this.state.ActualHeaderOrder.ZipCode}`, this.state.ActualHeaderOrder.State !== '' ? "State:" : "", this.state.ActualHeaderOrder.State !== '' ? this.state.ActualHeaderOrder.State : ""]}
                    headerTable={["\n Item Code", "\n Description", "\nPallet", "\n Quantity \n Ordered", mode === 'S/O' ? "\n Quantity \n Shipped" : "\n Quantity \n Received", "\n Total\n Weight", "\n Time\n Stamp", "User\nName\n"]}
                    bodyTable={this.formatDatePickedUp()}
                    headerBodyTable={["ItemCode", "ItemCodeDesc", "Pallet", "QuantityOrdered", "QuantityShipped", "TotalLineWeight", "receivedDate2", "UserName"]}
                    bottomInfo={["", "TOTALS:", "", NumberFormat(this.state.Totals.OrderDetailPicked.QuantityOrdered), NumberFormat(this.state.Totals.OrderDetailPicked.QuantityShipRec), NumberFormat(pricesFormat(this.state.Totals.OrderDetailPicked.TotalWeight)), "", ""]}
                    styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaTextoNormal", "ColumnaCantidades"]}
                    hidden={false} comment={''} breakpoint={30} keysDecimalFormat={["TotalLineWeight"]} titleButton='Print Order'
                  />
                ) : (
                  <DownloadOrderPDF
                    id={"PrintPickOrder"} disabled={this.state.ActualHeaderOrder.Status === ''} colorButton="blueButton" title="Print Order"
                    companyLogo={getValueCookie('DocumentsLogo')}
                    OrderTitle="Picked Up List"
                    contactInfo={this.state.companyPrintHeader}
                    OrderInfo1={["Order No: ", this.state.ActualHeaderOrder.OrderNo, "Order by: ", this.state.ActualHeaderOrder.SalesPerson, "No Vendor: ", this.state.ActualHeaderOrder.OrderNameNo, "Printed by: ", getValueCookie('userName'), "Vendor: ", this.state.ActualHeaderOrder.OrderName2, "Printed Date: ", FormatQueryReturnDateForReport(getActualDateUTC()), "Date: ", (formatInputDateQuery(this.state.ActualHeaderOrder.Date) !== "" ? formatInputDateQuery(this.state.ActualHeaderOrder.Date) : DateFormatMAS90(this.state.ActualHeaderOrder.Date)), this.state.ActualHeaderOrder.ZipCode !== '' ? "Address:" : "", `${this.state.ActualHeaderOrder.OrderNameAddress}, ${this.state.ActualHeaderOrder.State}, ${this.state.ActualHeaderOrder.ZipCode}`, this.state.ActualHeaderOrder.State !== '' ? "State:" : "", this.state.ActualHeaderOrder.State !== '' ? this.state.ActualHeaderOrder.State : ""]}
                    headerTable={["\n Item Code", "\n Description", "\nPallet", "\n Quantity \n Ordered", mode === 'S/O' ? "\n Quantity \n Shipped" : "\n Quantity \n Received", "\n Total\n Weight", "\n Time\n Stamp", "User\nName\n"]}
                    bodyTable={this.formatDatePickedUp()}
                    headerBodyTable={["ItemCode", "ItemCodeDesc", "Pallet", "QuantityOrdered", "QuantityShipped", "TotalLineWeight", "receivedDate2", "UserName"]}
                    bottomInfo={["", "TOTALS:", "", NumberFormat(this.state.Totals.OrderDetailPicked.QuantityOrdered), NumberFormat(this.state.Totals.OrderDetailPicked.QuantityShipRec), NumberFormat(pricesFormat(this.state.Totals.OrderDetailPicked.TotalWeight)), "", ""]}
                    styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaTextoNormal", "ColumnaCantidades"]}
                    hidden={false} comment={''} breakpoint={30} keysDecimalFormat={["TotalLineWeight"]} titleButton='Print Order'
                    docname={this.state.ActualHeaderOrder.OrderNo}
                  />
                )}
              </div>
            </div>
          )}
        </div>

            {/* <div className='row d-flex justify-content-center pb-4'>
              <div className='col-md-10 InputText'>
                <div  className="card shadow">
                  <div className="card-body">
                    <div className="input-group input-group-lg flex-nowrap" style={{ marginBottom: 0 }}>
                      <input type="text" autoComplete='off' className="form-control inputResize" disabled value={this.state.ActualHeaderOrder.OrderNo} id='OrderNoPickingSystem' onClick={() => this.getActualOrders()} />

                      <button type="button" className={"button " + this.state.General.Colorclass + " btn-lg"} style={{ fontWeight: 'normal', fontSize: '1rem', paddingLeft: 35, paddingRight: 35 }} onClick={() => this.changeMode()}>{this.state.General.Mode + " Mode"}</button>

                      <button type="button" className="btn blueButton btn-lg shadow" onClick={() => this.getActualOrders()}><AiOutlineSearch /></button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

        {/* Modal: Open SO/PO List */}
        <ModalOrders title={'Open ' + this.state.General.ModeTitle} show={this.state.General.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
            <input type="text" autoComplete='off'
              className="form-control form-control-lg"
              style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
              value={this.state.searchText || ''} onChange={(e) => this.handleSearchInput(e.target.value)} />
            <button type="button" onClick={this.handleSearchOrders}
              style={{ background: 'linear-gradient(135deg, #1e40af, #2563EB)', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0 1.25rem', fontSize: '1.1rem', cursor: 'pointer' }}>
              <AiOutlineSearch />
            </button>
          </div>
          <div className="tableFixHeadSmall">
            <table className="table table-clean mb-0">
              <thead>
                <tr className="text-center">
                  <th onClick={() => this.GeneralOrder('Status', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Status {sortArrows}</th>
                  <th onClick={() => this.GeneralOrder('OrderNo', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Order {sortArrows}</th>
                  <th onClick={() => this.GeneralOrder('OrderName', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Customer {sortArrows}</th>
                  <th hidden={mode === 'P/O'} onClick={() => this.GeneralOrder('PriceLevel', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Price Level {sortArrows}</th>
                  <th hidden={mode === 'S/O'} onClick={() => this.GeneralOrder('completionDate', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Est. Complete {sortArrows}</th>
                  <th onClick={() => this.GeneralOrder('Date', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Updated {sortArrows}</th>
                  <th hidden onClick={() => this.GeneralOrder('CompleteDate', this.state.order, 'filteredOrderList')}>Completed</th>
                  <th onClick={() => this.GeneralOrder('SalesPerson', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Sales Person {sortArrows}</th>
                  <th hidden={mode === 'P/O'} onClick={() => this.GeneralOrder('PosQue', this.state.order, 'filteredOrderList')} style={{ cursor: 'pointer' }}>Queue {sortArrows}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.filteredOrderList.map((order, i) => {
                  // 2026-09-18 fix (client-reported, AL65250 case) — this used to
                  // hide any row whose OrderType wasn't exactly 'S' ("!== 'S'"),
                  // which silently hid legitimate orders with a blank/unexpected
                  // OrderType (a MAS90-side data gap, not a real Quote) with zero
                  // visible trace — only the footer's row count changed. Quotes
                  // ('Q', confirmed real Sage code — see SalesOrderReport.js's
                  // `order.OrderType === 'Q'` filter) are the only ones that
                  // should never show up for picking; anything else (Standard,
                  // or blank because of the MAS90 import gap) should still be
                  // visible, flagged with a warning instead of disappearing.
                  const isQuote = order.OrderType === 'Q';
                  const hasOrderTypeIssue = mode === 'S/O' && !isQuote && order.OrderType !== 'S';
                  return (
                  <tr key={i}
                    hidden={isQuote && mode === 'S/O'}
                    onClick={() => this.SelectOrdertoPickUp(order)}
                    className={modalRowClass(order.Status)}
                    style={{ cursor: 'pointer' }}>
                    <td className="text-center">
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', fontWeight: 700, fontSize: '0.8rem', color: (order.Status === 2 || order.Status === '2') ? '#059669' : (order.Status === 1 || order.Status === '1') ? '#D97706' : '#DC2626' }}>
                        {this.statusIcon(order.Status, mode)}
                        {this.stateInWords(order.Status)}
                      </span>
                    </td>
                    <td className="text-center" style={{ fontWeight: 700, color: '#334155' }}>
                      {order.OrderNo}
                      {hasOrderTypeIssue && (
                        <span title="Order Type en blanco/inesperado en MAS90 — verificar la orden directamente en Sage antes de surtir."
                          style={{ display: 'inline-block', marginLeft: '0.4rem', background: 'rgba(245,158,11,0.08)', color: '#92400E', border: '1px solid #FDE68A', borderRadius: '6px', padding: '1px 6px', fontSize: '0.65rem', fontWeight: 700 }}>
                          ⚠ Verificar en MAS90
                        </span>
                      )}
                    </td>
                    <td>{order.OrderName}</td>
                    <td className="text-center" hidden={mode === 'P/O'}>{order.PriceLevel}</td>
                    <td className="text-center" hidden={mode === 'S/O'}>{formatInputDateQuery(order.completionDate)}</td>
                    <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>
                      {formatInputDateQuery(order.Date) !== "" ? formatInputDateQuery(order.Date) : DateFormatMAS90(order.Date) + " " + order.DateTime}
                    </td>
                    <td hidden>{order.CompleteDate}</td>
                    <td className="text-center">{order.SalesPerson}</td>
                    <td hidden={mode === 'P/O'} className="text-center">
                      {order.PosQue === 999 ? (
                        <span style={{ background: 'rgba(16,185,129,0.1)', color: '#059669', border: '1px solid #A7F3D0', borderRadius: '6px', padding: '2px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                          <AiOutlineCheckCircle size={12} />
                        </span>
                      ) : (
                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                          {order.PosQue}
                        </span>
                      )}
                    </td>
                  </tr>
                  );
                })}
              </tbody>
              <tfoot className="tfoot"><tr><td colSpan={9}>{this.state.filteredOrderList.length} orders</td></tr></tfoot>
            </table>
          </div>
        </ModalOrders>

        {/* Modal: Pick item (Quantity to Pack / Received) */}
        <ModalOrders title={mode === 'S/O' ? 'Quantity to Pack' : 'Quantity Received'} show={this.state.General.showModal2} close={(modal = "showModal2") => this.handleModalClose(modal)}>
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
            {/* Product image */}
            <div style={{ width: '160px', flexShrink: 0 }}>
              <div className='image-box'>
                <div className='ItemImage'>
                  <img key={this.state.CurrentItem.ImgURL} id='ShortsProductImg'
                    src={(this.state.CurrentItem.ImgURL && this.state.CurrentItem.ImgURL !== '') ? this.state.CurrentItem.ImgURL : '/assets/notavailable.png'}
                    alt='ProductImg' style={{ width: '100%', height: 'auto', borderRadius: '10px', border: '1px solid #E2E8F0' }} />
                </div>
              </div>
            </div>

            {/* Info + inputs */}
            <div style={{ flex: 1, minWidth: 0 }}>
              {/* Item header */}
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '3px 9px', fontSize: '0.8rem', fontWeight: 700, marginRight: '0.5rem' }}>
                  {this.state.CurrentItem.ItemCode}
                </span>
                <span style={{ fontWeight: 600, color: '#0F172A', fontSize: '0.9rem' }}>{this.state.CurrentItem.Description.longDescription || this.state.CurrentItem.Description.Description}</span>
              </div>

              {/* KV boxes */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginBottom: '1rem' }}>
                <div className="pol-kv-box">
                  <span>BIN</span>
                  <strong>{this.state.CurrentItem.BIN || '—'}</strong>
                </div>
                <div className="pol-kv-box">
                  <span>On Hand</span>
                  <strong>{this.state.CurrentItem.onHand}</strong>
                </div>
                <div className="pol-kv-box">
                  <span>Qty Ordered</span>
                  <strong>{this.state.CurrentItem.QuantityOrdered}</strong>
                </div>
              </div>

              {/* Pallet + Qty inputs */}
              <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.875rem', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '110px' }}>
                  <label style={{ fontSize: '0.78rem', color: '#64748B', fontWeight: 600, marginBottom: '0.3rem', display: 'block' }}>Pallet</label>
                  <select defaultValue={this.state.General.currentPallet}
                    className="form-select form-select-lg" id='palletPickingSystem' onChange={this.onTarget}
                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}>
                    {['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16'].map(p => (
                      <option key={p}>{p}</option>
                    ))}
                  </select>
                </div>
                <div style={{ flex: 2, minWidth: '140px' }}>
                  <label style={{ fontSize: '0.78rem', color: '#64748B', fontWeight: 600, marginBottom: '0.3rem', display: 'block' }}>{mode === 'S/O' ? 'Qty Shipped' : 'Qty Received'}</label>
                  <input type="number" min={0} autoComplete='off'
                    onChange={(e) => this.changeInputShipped(e)}
                    defaultValue={this.state.CurrentItem.QuantityShipRec}
                    className="form-control form-control-lg"
                    id='quantityShipRecPickingSystem'
                    style={{ borderRadius: '8px', border: '1.5px solid #2563EB', textAlign: 'center', fontWeight: 800, fontSize: '1.5rem', color: '#1e40af' }} />
                </div>
              </div>

              {mode === 'P/O' && (
                <div style={{ marginBottom: '0.875rem' }}>
                  <label style={{ fontSize: '0.78rem', color: '#64748B', fontWeight: 600, marginBottom: '0.3rem', display: 'block' }}>Expiration Date</label>
                  <input type="date" autoComplete='off'
                    value={this.state.CurrentItem.DueDate ? this.formatDate(this.state.CurrentItem.DueDate) : this.state.CurrentItem.DueDate}
                    onChange={(e) => this.changeDueDate(e)}
                    className="form-control form-control-lg" id='dueDatePickingSystem'
                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                </div>
              )}

              <hr style={{ borderColor: '#E2E8F0', margin: '1rem 0' }} />

              <div style={{ display: 'flex', gap: '0.625rem' }}>
                <button type="button" onClick={() => this.confirmPickItem()}
                  style={{ flex: 1, background: 'linear-gradient(135deg, #1e40af, #2563EB)', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.75rem', fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
                  <AiOutlineCheckCircle /> Confirm
                </button>
                <button type="button" onClick={() => this.handleModalClose("showModal2")}
                  style={{ flex: 1, background: 'white', border: '1.5px solid #E2E8F0', borderRadius: '8px', color: '#64748B', fontWeight: 700, padding: '0.75rem', fontSize: '1rem', cursor: 'pointer' }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </ModalOrders>
      </div>
    )
  }
}
